<template>
    <v-dialog v-model="dialog" class="modalSettings" persistent max-width="510px" @keydown.esc="closeModal()">
        <v-card :loading="getingProducts" min-height="446px">
            <v-container class="modal__container" style="padding-bottom: 36px;">
                <div class="modal__container__div--Btn">
                    <v-btn class="modal__container__btn__close" text @click="closeModal()">
                        <span class="modal__container__btn__close--span"> x </span>                    
                    </v-btn>
                </div>
                <v-card-title class="modal__container__cardtitle" style="max-width: 450px">
                    <div class="text-truncate">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <span v-on="on"> {{ offerTitle }}</span>
                            </template>
                            {{ offerTitle }}
                        </v-tooltip>
                    </div>
                                     
                </v-card-title>
                <v-card-text class="modal__container__cardtext--pd">
                    <v-container class="no-pd container-overflow" v-if="products.length > 0">
                        <v-card class="product_card" v-for="product in  products" :key="product.productId" @click="goToOfferDetail(product.participantId)">
                            <v-card-title class="no-pd no-mg">
                                <v-img
                                  :contain="product.image"
                                  class="img--custom"
                                  height="180px" 
                                  :src="product.image ? product.image : imgDefault"/>
                            </v-card-title>
                            <div class="discount_brand text-white flex-row-center">Desconto {{product.discountPercent +"%" }}</div>
                            <v-card-text class="flex-col-center">
                                <div class="product_name text-truncate">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on"> {{ product.name}}</span>
                                        </template>
                                            {{ product.name}}
                                    </v-tooltip>
                                </div>
                                <div class="flex-row-start">
                                    <span class="product_card_old_price text-truncate"><strike>{{'R$ ' + product.price.toFixed(2)}}</strike></span>
                                    <div class="product_card_price text-truncate">{{ 'R$' + product.discountedPrice.toFixed(2) }}</div>
                                </div>
                                <div v-show="product.maxRedeems">
                                    <span>
                                        <strong>Disponível: </strong>
                                        {{product.maxRedeems}}
                                    </span> 
                                </div>                                
                            </v-card-text>
                        </v-card>
                    </v-container>
                </v-card-text>
            </v-container>
        </v-card>
    </v-dialog>  
</template>

<script>
//Store
import { mapGetters } from "vuex";

//Services
import { getOfferInfoRedeems } from "@/app/components/offers/service/offers.service";

export default {
    name: "offerRedeems",
    computed: {
        ...mapGetters('authenticateStore', {
            currentCompany: 'get_currentCompany'
        })
    },
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        offerTitle: {
            type: String,
            required: false
        },
        localOfferId: {
            type: Number,
            required: false
        }
    },
    data: () => ({
        getingProducts: false,
        products: [],
        imgDefault: require('@/assets/communicate_default_image.png')
    }),
    watch: {
        dialog(){
            if(this.dialog) this.getModalInfo()
        }
    },
    methods: {
        closeModal() {
            this.products = []
            this.participantIdLocal = null
            this.$emit('closeOfferRedeemstModal', false)
        },
        getModalInfo(){
            this.getingProducts = true
            getOfferInfoRedeems(this.currentCompany.id, this.localOfferId)
                .then( success => {
                    this.products = success.data.participants;
                    this.getingProducts = false;
                })
                .catch( error => {
                        this.getingProducts = false;
                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        goToOfferDetail(participantId){
            this.$router.push({path: `/detalheOferta?participantId=${participantId}`})
        }
    }
}
</script>

<style scoped>
::v-deep .v-dialog {
    border-radius: 12px;
}
.product_card{
    margin-left: 15px !important;
    height: 332px;
    min-width: 200px;
    max-width: 200px;
    border-radius: 8px !important;
}
.product_card_price{
    color: var(--cor--verde);
    font-weight: 600;
    font-size: 16px;
    padding-left: 5px;
    max-width: 90px;
}
.discount_brand{
    background-color: orange;
    width: 100%;
}
.product_name{
    color: var(--cor--preta);
    font-size: 15px;
    padding: 5px;
    max-width: 180px;
    text-align: center;
}
.product-action-btn{
    position: relative;
    top: 14px;
}
.action-btn{
    border-radius: 10px;    
}
.container-overflow {
    display: flex;
    flex: auto;
    flex-direction: row;
    justify-content: start;
    max-width: 438px;
    height: 358px;    
    overflow: auto;
}
.product_card_old_price {
    max-width: 90px;
}
.img--custom {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

</style>